import { WidgetStorageId } from '@/types/enums/WidgetStorageId';
import storage from 'local-storage-fallback';

export const formatDate = (date: Date, options: Intl.DateTimeFormatOptions) => {
  const locale = storage.getItem(WidgetStorageId.WidgetLanguage) || 'en';
  return Intl.DateTimeFormat(locale, options).format(date);
};
